class StyleManager {
  constructor({
    color,
    backgroundColor,
    borderColor,
    colorHover,
    backgroundColorHover,
    borderColorHover
  }) {
    this.color = color;
    this.backgroundColor = backgroundColor;
    this.borderColor = borderColor;
    this.colorHover = colorHover;
    this.backgroundColorHover = backgroundColorHover;
    this.borderColorHover = borderColorHover;
  }

  getStyle({ isActive }) {
    const baseStyles = {
      '--color': isActive ? this.colorHover : this.color,
      '--backgroundColor': isActive ? this.backgroundColorHover : this.backgroundColor,
      '--borderColor': this.borderColor
    };

    const hoverStyles = {
      '--colorHover': this.colorHover,
      '--borderColorHover': this.borderColorHover,
      '--backgroundColorHover': this.backgroundColorHover
    };

    return { ...baseStyles, ...hoverStyles };
  }
}

export default StyleManager;
